import React from "react";
import "../App.css";
// import dentistImg from "../assets/dentist.jpg"; // Replace with your image path
import dentistImg from "../Images/HomeBannerFinal.png";
import { FaPhoneAlt } from "react-icons/fa";
import AppointmentBtn from "./AppointmentBtn";
import "../Styles/HomeBanner.css";

const HomeBanner = () => {
  return (
    <section className="home-banner">
      <div className="left-section">
        <h1>
          Get Ready For Your Best
          <br />
          <span className="highlight">Ever Dental Experience!</span>
        </h1>
        <p>
          We use only the best quality materials on the market in order to
          provide the best products to our patients, So don’t worry about
          anything and book yourself.
        </p>
        <div className="cta-buttons">
          <AppointmentBtn />
          <div className="emergency">
            <div className="phone-icon">
              <FaPhoneAlt className="phone-icon-style" />
            </div>
            <div className="emergency-text">
              <span className="label">Contact Us On</span>
              <br />
              <span className="number">+91 9343109693</span>
            </div>
          </div>
        </div>

        <div className="testimonial">
          <div>
            <strong>Dhotrad's Sunny Dental and Orthodontic Clinic</strong>
            <p className="subtitle">Multi Speciality Dental Clinic in Hubli</p>
            <p className="review">
              Top Quality dental and orthodontic treatment done by field
              experts, Highly recommended in Hubli.
            </p>
          </div>
          <a
            className="linkedin"
            href="https://www.linkedin.com/in/dhotrad-s-sunny-dental-clinics-639b701b2/?originalSubdomain=in"
          >
            <img
              src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
              alt="LinkedIn"
            />
          </a>
        </div>
      </div>
      <div className="right-section">
        <img src={dentistImg} alt="Dentist" />
      </div>
    </section>
  );
};

export default HomeBanner;
